/**
 *  @class
 *  @function FreeShipping
 */
  var confettiShown = false;

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

     connectedCallback() {
      this.checkShippingStatus(); // Run initiall
    }
    
    checkShippingStatus() {
      let amountText = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amountText) {
          let remaining = minimum - total;
          let format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
        confettiShown = false;
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
        if (!confettiShown) {
          if (document.body.classList.contains('template-cart') || !document.getElementById('Cart-Drawer').hasAttribute('inert')) {
            confettiShown = true;
            var duration = 1000;
            var end = Date.now() + duration;
            
            (function frame() {
              confetti({
                particleCount: 7,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
                colors: ['#FFFFFF', '#0165BD', '#C60C30', '#D8D8D8']
              });
              
              confetti({
                particleCount: 7,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
                colors: ['#FFFFFF', '#0165BD', '#C60C30', '#D8D8D8']
              });
              if (Date.now() < end) {
                requestAnimationFrame(frame);
              }
            }());
          }
        }
      }

      this.style.setProperty('--percentage', percentage);
      if(percentage == 0 || percentage < 0.5){
       this.classList.add('less-value'); 
      }else{
       this.classList.remove('less-value'); 
      }
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
